// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2u8Nt","title":"styles_title__34NPn"};